import React, { useState } from 'react'
import { FormControl, InputLabel, MenuItem, Select, InputAdornment, IconButton, Dialog, Button } from '@material-ui/core';
import label from '../utils/label'
import MapsIcon from '@material-ui/icons/Map'
import useOnlineStatus from '../hooks/useOnlineStatus'
import LocationPicker from './LocationPicker';
import Header from './Header';
import { makeStyles } from "@material-ui/core"
import BottomNavigationCustom from './BottomNavigationCustom';

const PlotFilter = ({ plot, setPlot, plots }) => {
    const [open, setOpen] = useState(false)
    const useStyles = makeStyles({
        select: {
            "& .MuiSvgIcon-root": {
                position: 'relative',
                marginLeft: '-10px',
            },
        },
    });
    const classes = useStyles()

    return (
        <>
            <FormControl fullWidth={true}>
                <InputLabel id="label_plot">{label('telgebied')}</InputLabel>
                <Select
                    className={classes.select}
                    labelId="label_plot"
                    id="select_plot"
                    value={plot}
                    onChange={(e) => setPlot(e.target.value)}
                    endAdornment={parseInt(process.env.REACT_APP_PROJECTID) !== 61 &&
                        <InputAdornment position="end">
                            <IconButton aria-label="toon telgebieden" onClick={(e) => setOpen(true)} >
                                <MapsIcon />
                            </IconButton>
                        </InputAdornment>
                    }
                >
                    <MenuItem value={-1} key={-1}>Alle gebieden</MenuItem>
                    {plots && plots.length > 0 ?
                        plots.map((item, i) => (
                            <MenuItem style={{ whiteSpace: 'normal' }} value={item.id} key={item.id}>{item.description}</MenuItem>
                        )) : null}
                </Select>
            </FormControl>
            {parseInt(process.env.REACT_APP_PROJECTID) === 61 &&
            <Button style={{ textTransform: 'none' }} variant="text" startIcon={<MapsIcon />}
                onClick={() => setOpen(true)}>
                Selecteer via kaart...
            </Button>}
                <Dialog open={open} fullScreen={true}>
                <Header backAction={() => setOpen(false)} title="Kies een object/locatie" />
                <LocationPicker
                    onSelect={() => setOpen(false)}
                    setPlot={setPlot}
                    plot={plot}
                    plots={plots.filter(item => item.location)}
                />
                <BottomNavigationCustom />
            </Dialog>
        </>
    )
}

export default PlotFilter
